import { LeadsBrowserProvider } from './leads-browser.provider';
import { LeadsBrowser } from './leads-browser.view';

export function FeatureLeadsBrowser() {
   return (
      <LeadsBrowserProvider>
         <LeadsBrowser />
      </LeadsBrowserProvider>
   );
}
